


// document.addEventListener('DOMContentLoaded', function() {
//     initTabbedCollections();
//     initMobileSliders();
//   });
  
//   function initTabbedCollections() {
//     const tabSections = document.querySelectorAll('.tabbed-collections');
    
//     tabSections.forEach(section => {
//       const tabButtons = section.querySelectorAll('.tab-button');
//       const tabPanels = section.querySelectorAll('.tab-panel');
      
//       tabButtons.forEach((button, index) => {
//         button.addEventListener('click', function() {
//           // Deactivate all tabs
//           tabButtons.forEach(tab => {
//             tab.setAttribute('aria-selected', 'false');
//             tab.parentElement.classList.remove('active');
//           });
          
//           // Hide all panels
//           tabPanels.forEach(panel => {
//             panel.classList.remove('active');
//           });
          
//           // Activate current tab
//           this.setAttribute('aria-selected', 'true');
//           this.parentElement.classList.add('active');
          
//           // Show current panel
//           tabPanels[index].classList.add('active');
//         });
//       });
//     });
//   }
  
//   function initMobileSliders() {
//     const mobileSliders = document.querySelectorAll('.mobile-slider');
    
//     mobileSliders.forEach(slider => {
//       const track = slider.querySelector('.slider-track');
//       const items = slider.querySelectorAll('.slider-item');
//       const dotsContainer = slider.querySelector('[data-slider-dots]');
//       const prevButton = slider.querySelector('[data-slider-control="prev"]');
//       const nextButton = slider.querySelector('[data-slider-control="next"]');
      
//       // Only set up slider if we have items
//       if (items.length === 0) return;
      
//       // Create dots
//       if (dotsContainer) {
//         items.forEach((_, index) => {
//           const dot = document.createElement('span');
//           dot.classList.add('slider-dot');
//           if (index === 0) dot.classList.add('active');
//           dot.setAttribute('data-index', index);
//           dot.addEventListener('click', () => {
//             scrollToItem(items[index]);
//             updateActiveDot(index);
//           });
//           dotsContainer.appendChild(dot);
//         });
//       }
      
//       // Set up navigation buttons
//       if (prevButton) {
//         prevButton.addEventListener('click', () => {
//           const currentIndex = getCurrentItemIndex(items);
//           const prevIndex = currentIndex > 0 ? currentIndex - 1 : items.length - 1;
//           scrollToItem(items[prevIndex]);
//           updateActiveDot(prevIndex);
//         });
//       }
      
//       if (nextButton) {
//         nextButton.addEventListener('click', () => {
//           const currentIndex = getCurrentItemIndex(items);
//           const nextIndex = currentIndex < items.length - 1 ? currentIndex + 1 : 0;
//           scrollToItem(items[nextIndex]);
//           updateActiveDot(nextIndex);
//         });
//       }
      
//       // Update on scroll
//       track.addEventListener('scroll', debounce(() => {
//         const currentIndex = getCurrentItemIndex(items);
//         updateActiveDot(currentIndex);
//       }, 100));
      
//       // Helper functions
//       function getCurrentItemIndex(items) {
//         const containerRect = track.getBoundingClientRect();
//         let closest = 0;
//         let closestDistance = Infinity;
        
//         items.forEach((item, index) => {
//           const itemRect = item.getBoundingClientRect();
//           const distance = Math.abs(itemRect.left - containerRect.left);
          
//           if (distance < closestDistance) {
//             closestDistance = distance;
//             closest = index;
//           }
//         });
        
//         return closest;
//       }
      
//       function scrollToItem(item) {
//         const containerRect = track.getBoundingClientRect();
//         const itemRect = item.getBoundingClientRect();
//         const offset = itemRect.left - containerRect.left + track.scrollLeft;
        
//         track.scrollTo({
//           left: offset,
//           behavior: 'smooth'
//         });
//       }
      
//       function updateActiveDot(activeIndex) {
//         if (!dotsContainer) return;
        
//         const dots = dotsContainer.querySelectorAll('.slider-dot');
//         dots.forEach((dot, index) => {
//           if (index === activeIndex) {
//             dot.classList.add('active');
//           } else {
//             dot.classList.remove('active');
//           }
//         });
//       }
//     });
//   }
  
//   // Debounce function to limit execution rate
//   function debounce(func, wait) {
//     let timeout;
//     return function executedFunction(...args) {
//       const later = () => {
//         clearTimeout(timeout);
//         func(...args);
//       };
//       clearTimeout(timeout);
//       timeout = setTimeout(later, wait);
//     };
//   }
  
//   // Re-initialize when Shopify section is reloaded
//   if (typeof Shopify !== 'undefined' && Shopify.designMode) {
//     document.addEventListener('shopify:section:load', function(event) {
//       if (event.target.querySelector('.tabbed-collections')) {
//         initTabbedCollections();
//         initMobileSliders();
//       }
//     });
//   }

document.addEventListener('DOMContentLoaded', function() {
  initTabbedCollections();
  initSlickSliders();
  
  // Handle window resize to reinitialize sliders
  let resizeTimer;
  window.addEventListener('resize', function() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function() {
      checkSlickInit();
    }, 250);
  });
});

function initTabbedCollections() {
  const tabSections = document.querySelectorAll('.tabbed-collections');
  
  tabSections.forEach(section => {
    const tabButtons = section.querySelectorAll('.tab-button');
    const tabPanels = section.querySelectorAll('.tab-panel');
    
    tabButtons.forEach((button, index) => {
      button.addEventListener('click', function() {
        // Deactivate all tabs
        tabButtons.forEach(tab => {
          tab.setAttribute('aria-selected', 'false');
          tab.parentElement.classList.remove('active');
        });
        
        // Hide all panels
        tabPanels.forEach(panel => {
          panel.classList.remove('active');
        });
        
        // Activate current tab
        this.setAttribute('aria-selected', 'true');
        this.parentElement.classList.add('active');
        
        // Show current panel
        tabPanels[index].classList.add('active');
        
        // Reinitialize slick slider for the active tab
        const slider = tabPanels[index].querySelector('.product-slider');
        if (slider && window.innerWidth < 750) {
          // If slick is already initialized, refresh it
          if ($(slider).hasClass('slick-initialized')) {
            $(slider).slick('setPosition');
          }
        }
      });
    });
  });
}

// function initSlickSliders() {
//   // Only initialize slick on mobile
//   if (window.innerWidth < 750) {
//     const productSliders = document.querySelectorAll('.product-slider');
    
//     productSliders.forEach(slider => {
//       const sliderId = slider.getAttribute('data-slider-id');
//       const tabPanel = slider.closest('.tab-panel');
//       const showControls = tabPanel && tabPanel.querySelector('[data-slider-control]') !== null;
      
//       // Initialize Slick slider
//       $(slider).slick({
//         dots: true,
//         arrows: showControls,
//         infinite: true,
//         speed: 300,
//         slidesToShow: 2.1,
//         slidesToScroll: 1,
//         centerMode: true,
//         adaptiveHeight: true,
//         autoplay: false,
//         responsive: [
//           {
//             breakpoint: 480,
//             settings: {
//             }
//           }
//         ]
//       });
//     });
//   }
// }

function initSlickSliders() {
  // Only initialize slick on mobile
  if (window.innerWidth < 750) {
    const productSliders = document.querySelectorAll('.product-slider');

    productSliders.forEach(slider => {
      const sliderId = slider.getAttribute('data-slider-id');
      const tabPanel = slider.closest('.tab-panel');
      const showControls = tabPanel && tabPanel.querySelector('[data-slider-control]') !== null;

      // Attach 'init' event to add custom next arrow
      $(slider).on('init', function (event, slick) {
        const nextArrow = `
          <div class="custom-arrow custom-next">
            <svg xmlns="http://www.w3.org/2000/svg" width="17.086" height="10.243" viewBox="0 0 17.086 10.243">
              <path d="M0 1.7L1.702 0 7.843 5.64 14.684 0l1.7 1.7L8.543 10.243 0 1.7z" fill="#4B3F8A"/>
            </svg>
          </div>`;
        
        setTimeout(() => {
          $(slider).find('.slick-dots').append(nextArrow);
          $(slider).find('.custom-next').on('click', function () {
            $(slider).slick('slickNext');
          });
        }, 0);
      });

      // Initialize Slick slider
      $(slider).slick({
        // dots: true,
        // arrows: showControls,
        // infinite: true,
        // speed: 300,
        // slidesToShow: 2,
        // slidesToScroll: 1,
        // adaptiveHeight: true,
        // autoplay: false,
          dots: true,
  arrows: showControls,
  infinite: true,
  speed: 300,
  slidesToShow: 2,
  slidesToScroll: 1,
  adaptiveHeight: true,
  autoplay: false,
  // centerMode: true,           // Centers the current slide
  centerPadding: '20px',      // Adds padding around centered slides
  focusOnSelect: true,        // Allows clicking on slides to center them

      });
    


    });
  }
}

function initOcularSlider() {
  if (window.innerWidth < 750) {
    const ocularSliders = document.querySelectorAll('.product-slider-ocular');

    ocularSliders.forEach(slider => {
      const tabPanel = slider.closest('.tab-panel');
      const showControls = tabPanel && tabPanel.querySelector('[data-slider-control]') !== null;

      // Attach 'init' event to add custom next arrow
      $(slider).on('init', function (event, slick) {
        const nextArrow = `
          <div class="custom-arrow custom-next">
            <svg xmlns="http://www.w3.org/2000/svg" width="17.086" height="10.243" viewBox="0 0 17.086 10.243">
              <path d="M0 1.7L1.702 0 7.843 5.64 14.684 0l1.7 1.7L8.543 10.243 0 1.7z" fill="#4B3F8A"/>
            </svg>
          </div>`;

        setTimeout(() => {
          $(slider).find('.slick-dots').append(nextArrow);
          $(slider).find('.custom-next').on('click', function () {
            $(slider).slick('slickNext');
          });
        }, 0);
      });

      // Initialize slick for ocular slider
      $(slider).slick({
        // dots: true,
        // arrows: showControls,
        // infinite: true,
        // speed: 300,
        // slidesToShow: 2,
        // slidesToScroll: 1,
        // adaptiveHeight: true,
        // autoplay: false,

          dots: true,
  arrows: showControls,
  infinite: true,
  speed: 300,
  slidesToShow: 2,
  slidesToScroll: 1,
  adaptiveHeight: true,
  autoplay: false,
  // centerMode: true,           // Centers the current slide
  centerPadding: '20px',      // Adds padding around centered slides
  focusOnSelect: true,        // Allows clicking on slides to center them

      });
    });
  }
}

document.addEventListener('DOMContentLoaded', function () {
  initOcularSlider();     // for .product-slider-ocular
});


// function checkSlickInit() {
//   const productSliders = document.querySelectorAll('.product-slider');
  
//   productSliders.forEach(slider => {
//     if (window.innerWidth < 750) {
//       // If not initialized, initialize slick
//       if (!$(slider).hasClass('slick-initialized')) {
//         const sliderId = slider.getAttribute('data-slider-id');
//         const tabPanel = slider.closest('.tab-panel');
//         const showControls = tabPanel && tabPanel.querySelector('[data-slider-control]') !== null;
        
//         $(slider).slick({
//           dots: true,
//           arrows: showControls,
//           infinite: true,
//           speed: 300,
//           slidesToShow: 2.1,
//           slidesToScroll: 1,
//           centerMode: true,
//           adaptiveHeight: true,
//           autoplay: false,
//           responsive: [
//             {
//               breakpoint: 480,
//               settings: {
//               }
//             }
//           ]
//         });
//       }
//     } else {
//       // If initialized, destroy slick
//       if ($(slider).hasClass('slick-initialized')) {
//         $(slider).slick('unslick');
//       }
//     }
//   });
// }
function checkSlickInit() {
  const productSliders = document.querySelectorAll('.product-slider');

  productSliders.forEach(slider => {
    if (window.innerWidth < 750) {
      // If not initialized, initialize slick
      if (!$(slider).hasClass('slick-initialized')) {
        const sliderId = slider.getAttribute('data-slider-id');
        const tabPanel = slider.closest('.tab-panel');
        const showControls = tabPanel && tabPanel.querySelector('[data-slider-control]') !== null;

        // Attach 'init' event before initializing
        $(slider).on('init', function (event, slick) {
          const nextArrow = `
            <div class="custom-arrow custom-next">
              <svg xmlns="http://www.w3.org/2000/svg" width="17.086" height="10.243" viewBox="0 0 17.086 10.243">
                <path d="M0 1.7L1.702 0 7.843 5.64 14.684 0l1.7 1.7L8.543 10.243 0 1.7z" fill="#4B3F8A"/>
              </svg>
            </div>`;
          
          setTimeout(() => {
            $(slider).find('.slick-dots').append(nextArrow);
            $(slider).find('.custom-next').on('click', function () {
              $(slider).slick('slickNext');
            });
          }, 0);
        });

        $(slider).slick({
          dots: true,
          arrows: showControls,
          infinite: true,
          speed: 300,
          slidesToShow: 2.1,
          slidesToScroll: 1,
          adaptiveHeight: true,
          autoplay: false,
          responsive: [
            {
              breakpoint: 480,
              settings: {
                slidesToShow: 1.2
              }
            }
          ]
        });
      }
    } else {
      // If initialized, destroy slick
      if ($(slider).hasClass('slick-initialized')) {
        $(slider).slick('unslick');
      }
    }
  });
}


// Re-initialize when Shopify section is reloaded
if (typeof Shopify !== 'undefined' && Shopify.designMode) {
  document.addEventListener('shopify:section:load', function(event) {
    if (event.target.querySelector('.tabbed-collections')) {
      initTabbedCollections();
      setTimeout(function() {
        checkSlickInit();
      }, 100);
    }
  });
}

document.addEventListener('DOMContentLoaded', function() {
  const productLinks = document.querySelectorAll('.full-unstyled-link');
  productLinks.forEach(link => {
    const fullTitle = link.textContent.trim();
    // Check for both product prefixes
    const prefixes = ['AmcoreMatrix', 'AmchoPlast'];
    for (const prefix of prefixes) {
      if (fullTitle.startsWith(prefix)) {
        const suffix = fullTitle.substring(prefix.length);
        if (suffix) {
          link.innerHTML = `${prefix}<sup>${suffix}</sup>`;
          break; // Stop after finding the first match
        }
      }
    }
  });
});

  document.addEventListener('DOMContentLoaded', function () {
    const container = document.querySelector('.section-title-container');
    let startX = 0;

    window.addEventListener('touchstart', function (e) {
      startX = e.touches[0].clientX;
    });

    window.addEventListener('touchmove', function (e) {
      const currentX = e.touches[0].clientX;
      const diffX = currentX - startX;

      if (Math.abs(diffX) > 30) {
        container.classList.add('no-left-padding');
      }
    });

    window.addEventListener('touchend', function () {
      // Restore padding if swipe ends near the origin (e.g., leftmost)
      if (window.scrollX === 0) {
        container.classList.remove('no-left-padding');
      }
    });
  });
